"use strict"
exports.__esModule = true;
exports.GooglePlusIconConfig = {
  name: 'GooglePlusIcon',
  height: 512,
  width: 512,
  svgPath: 'M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z',
  yOffset: 0,
  xOffset: 0,
};
exports.GooglePlusIcon = require('../createIcon').createIcon(exports.GooglePlusIconConfig);
exports["default"] = exports.GooglePlusIcon;